import { useState, useEffect } from 'react';
import { windowSizes } from '../../constants';
export default () => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < windowSizes.MEDIUM_WIDTH);
        };
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => {
            window.removeEventListener('resize', checkIsMobile);
        };
    }, []);
    return isMobile;
};
//# sourceMappingURL=index.js.map